import React__default, { useContext } from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import { NvButton } from '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import { OrderGroupProductTypeEnum } from '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import styles from './MiniCart.module.esm.js';

var MiniCartActions = function (_a) {
    var _b;
    var disableProceedAction = _a.disableProceedAction, editAction = _a.editAction, editButtonTitle = _a.editButtonTitle, proceedAction = _a.proceedAction, proceedButtonTitle = _a.proceedButtonTitle, _c = _a.proceedIfValidOnly, proceedIfValidOnly = _c === void 0 ? false : _c;
    var _d = useContext(CartContext), cart = _d.cart, featureFlags = _d.featureFlags, meta = _d.meta, setHasInvalidExomeAddOnConfiguration = _d.setHasInvalidExomeAddOnConfiguration, setReflexValidationErrors = _d.setReflexValidationErrors, setRereqValidationError = _d.setRereqValidationError;
    var isReflexTestSelectionValid = React__default.useCallback(function () {
        var _a, _b;
        var validationErrors = {};
        cart === null || cart === void 0 ? void 0 : cart.orderGroups.forEach(function (_a) {
            var reflex = _a.meta.reflex, rereqSetCode = _a.rereqSetCode;
            var isReflexSelected = reflex.isReflexSelected, reflexConditions = reflex.reflexConditions, richReflexTests = reflex.richReflexTests;
            if (!isReflexSelected)
                return;
            var conditionMissing = !(reflexConditions === null || reflexConditions === void 0 ? void 0 : reflexConditions.length);
            var noTestsSelected = !(richReflexTests === null || richReflexTests === void 0 ? void 0 : richReflexTests.length);
            if (conditionMissing || noTestsSelected)
                validationErrors[rereqSetCode] = { conditionMissing: conditionMissing, noTestsSelected: noTestsSelected };
        });
        setReflexValidationErrors(validationErrors);
        var hasRereqValidationError = !!(((_a = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _a === void 0 ? void 0 : _a.isRerequisition) && !((_b = meta.rereq.richRereqTests) === null || _b === void 0 ? void 0 : _b.length));
        setRereqValidationError(hasRereqValidationError);
        return !Object.keys(validationErrors).length && !hasRereqValidationError;
    }, [cart, meta]);
    var isExomeAddOnConfigurationValid = React__default.useCallback(function () {
        var exome = (meta || {}).exome;
        var _a = exome || {}, addOnTargets = _a.addOnTargets, _b = _a.type, type = _b === void 0 ? '' : _b;
        var _c = addOnTargets || {}, father = _c.father, mother = _c.mother, proband = _c.proband;
        // If cart contains Exome Duo or Trio along with Exome Add-on
        if (['Duo', 'Trio'].includes(type) && addOnTargets) {
            // Check if add-on is requested for at least one person
            var isValid = father || mother || proband;
            if (!isValid) {
                setHasInvalidExomeAddOnConfiguration(true);
            }
            return isValid;
        }
        return true;
    }, [meta]);
    var proceedIfSelectionIsValid = React__default.useCallback(function (event) {
        event.stopPropagation();
        if (!proceedIfValidOnly) {
            proceedAction === null || proceedAction === void 0 ? void 0 : proceedAction();
            return;
        }
        if (isReflexTestSelectionValid() && isExomeAddOnConfigurationValid()) {
            proceedAction === null || proceedAction === void 0 ? void 0 : proceedAction();
        }
    }, [isExomeAddOnConfigurationValid, isReflexTestSelectionValid, proceedAction, proceedIfValidOnly]);
    var onEditAction = React__default.useCallback(function (event) {
        event.stopPropagation();
        editAction === null || editAction === void 0 ? void 0 : editAction();
    }, [editAction]);
    var shouldDisplayEditButton = function () {
        var orderGroups = (cart || {}).orderGroups;
        var isSingleProductOrder = (orderGroups === null || orderGroups === void 0 ? void 0 : orderGroups.length) === 1;
        var isFragileXDiagnostic = orderGroups === null || orderGroups === void 0 ? void 0 : orderGroups.some(function (item) { return item.productType === OrderGroupProductTypeEnum.FragileXDiagnostic; });
        return !(isSingleProductOrder && isFragileXDiagnostic && !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.cx_pediatric_cma_in_sf));
    };
    return (React__default.createElement("div", { className: styles.actions, "data-testid": "mini-cart-actions" },
        shouldDisplayEditButton() && editAction && (React__default.createElement(NvButton, { dataTestId: "cart-edit-button", onClick: onEditAction, size: "medium", variant: "secondary" }, editButtonTitle || 'Edit')),
        proceedAction && (React__default.createElement(NvButton, { dataTestId: "cart-proceed-button", disabled: disableProceedAction !== undefined ? disableProceedAction : !((_b = cart === null || cart === void 0 ? void 0 : cart.orderGroups) === null || _b === void 0 ? void 0 : _b.length), onClick: proceedIfSelectionIsValid, size: "medium" }, proceedButtonTitle || 'Proceed'))));
};

export { MiniCartActions as default };
//# sourceMappingURL=MiniCartActions.esm.js.map
